import _api from '../_api';

import Order from '../../../models/Order';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    orders: [],
    orderHistory: [],
    pageCount: 0,
    historyPageCount: 0,
    totalCount: 0,
    historyTotalCount: 0,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.orders,
    history: (state,) => state.orderHistory.
      sort((orderA, orderB,) =>
        ((orderA.order_date < orderB.order_date) ?
          1 : ((orderB.order_date < orderA.order_date) ? -1 : 0)),),
    filteredOrders: (state,) => (filters,) => state.orders.filter((item,) => {
      const confirmationArray = [];
      Object.entries(filters,).forEach((filter,) => {
        if (filter[1]) {
          if (filter[0] === 'sort') {
            return;
          } else if (filter[0] === 'status' && Array.isArray(filter[1],)) {
            if (filter[1].length) {confirmationArray.
              push(filter[1].includes(item[filter[0]],),);}
          } else if (typeof filter[1] === 'string') {
            if (Number.isFinite(item[filter[0]],)) {confirmationArray.
              push(
                item[filter[0]].
                  toString().toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0,
              );
            } else {
              confirmationArray.
                push(
                  item[filter[0]].toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0,
                );
            }
          } else {
            confirmationArray.push(item[filter[0]] === filter[1],);
          }
        }
      },);
      return !confirmationArray.filter((confirmation,) => confirmation === false,).length;
    },).
      sort((orderA, orderB,) =>
        filters.sort ?
          ((orderA[filters.sort] < orderB[filters.sort]) ?
            1 : ((orderB[filters.sort] < orderA[filters.sort]) ?
              -1 : 0)) : ((orderA.order_date < orderB.order_date) ?
            1 : ((orderB.order_date < orderA.order_date) ?
              -1 : 0)),),
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    historyPageCount: (state,) => state.historyPageCount,
    historyTotalCount: (state,) => state.historyTotalCount,
  },
  // -----------------------------------------------------------------
  mutations: {
    setOrders: (state, orders,) =>
      (state.orders = orders),
    setOrderHistory: (state, orderHistory,) =>
      (state.orderHistory = orderHistory),
    setPageCount: (state, pageCount,) =>
      (state.pageCount = pageCount),
    setHistoryPageCount: (state, historyPageCount,) =>
      (state.historyPageCount = historyPageCount),
    setTotalCount: (state, totalCount,) =>
      (state.totalCount = totalCount),
    setHistoryTotalCount: (state, historyTotalCount,) =>
      (state.historyTotalCount = historyTotalCount),
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit, },) => {
      commit('orders/setOrders', [], { root: true, },);

      return _api.get().then(
        (response,) => {
          const orders = response.data.items.map((order,) => new Order(order,),);
          commit('orders/setOrders', orders, { root: true, },);
          commit(
            'orders/setPageCount',
            Math.ceil(response.data.total_count / 15,),
            { root: true, },
          );
          commit('orders/setTotalCount', response.data.total_count, {
            root: true,
          },);
          return response;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getHistory: ({ commit, }, { begin_date, end_date, },) => {
      commit('orders/setOrderHistory', [], { root: true, },);

      return new Promise((resolve, reject,) => {
        _api.
          getOrderHistory({ begin_date, end_date, },).then(
            (response,) => {
              const orders = response.data.items.map((order,) => new Order(order,),);
              commit('orders/setOrderHistory', orders, { root: true, },);
              commit(
                'orders/setHistoryPageCount',
                Math.ceil(response.data.total_count / 15,),
                { root: true, },
              );
              commit('orders/setHistoryTotalCount', response.data.total_count, {
                root: true,
              },);
              return resolve(orders,);
            },
          ).catch((error,) => {
            return error.response?.status === 400 ?
              reject(error.response.data.errors[0],) : _api.handleError(error,);
          },);
      },);
    },
  },
};
